import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledLabelStandart } from './styles/StyledLabelStandart';


class LabelStandart extends Component {
  render() {
    const { title } = this.props;

    return (
      <StyledLabelStandart>
        <span>
          { title }
        </span>
      </StyledLabelStandart>
    );
  }
}


LabelStandart.propTypes = {
  title: PropTypes.string.isRequired,
};


export default LabelStandart;


// WEBPACK FOOTER //
// ./src/common/LabelStandart/LabelStandart.js